import React from 'react';
import Input from '@mui/material/Input';
import constants from '@shared-styles/constants.module.scss';

const ONLY_NUMBERS_REGEX = /\D/g;
const ONLY_NUMBERS_AND_SIGN_REGEX = /[^\d+-]/g;

/**
 * @typedef {object} MuiInputNumberProps
 * @property {string} [placeholder]
 * @property {boolean} [error]
 * @property {(inputNumber: number | string) => void} [handleChange]
 * @property {number|string} [value]
 * @property {boolean} [disabled]
 * @property {string} [dataTestId]
 * @property {boolean} [allowSignedNumber]
 * @property {*} [inputRef]
 */

/**
 * @param {MuiInputNumberProps} props
 */
const MuiInputNumber = props => {
  const {
    value,
    handleChange,
    inputRef,
    placeholder = '',
    error = false,
    disabled = false,
    dataTestId = '',
    allowSignedNumber = false
  } = props;

  const handleChangeInner = event => {
    const inputValue = event.target.value.replace(
      allowSignedNumber ? ONLY_NUMBERS_AND_SIGN_REGEX : ONLY_NUMBERS_REGEX,
      ''
    );
    const inputNumber = inputValue === '' ? null : Number(inputValue);

    handleChange(inputNumber);
  };

  return (
    <Input
      data-testid={dataTestId}
      disableUnderline
      inputProps={{
        step: 1
      }}
      error={error}
      disabled={disabled}
      value={value ?? ''}
      placeholder={placeholder}
      onChange={handleChangeInner}
      inputRef={inputRef}
      className='mui-transparent-input'
      sx={{
        boxSizing: 'border-box',
        padding: '5px 12px',
        width: '100%',
        height: 32,
        border: `1px solid ${constants.borderColor}`,
        borderRadius: '2px',
        '&.Mui-error': {
          border: `1px solid ${constants.validationErrorColor}`,
          borderRadius: 'initial'
        }
      }}
    />
  );
};

export default MuiInputNumber;
